module.exports = __webpack_public_path__ + "img/icon-015.1b94e4dd.png";